angular.module('smartorg.r6.mgmts.archivePortfolioFrom').directive('archivePortfolioFromExisting', ["$timeout", "terminologyService", function ($timeout, terminologyService) {
        return {
            restrict: 'E',
            template: require('../../template/archive-portfolio-from-existing.html'),
            scope: {
                refreshForArchivePortfolio: '&',
                smartorgApi: '=',
                terminology: '=?'
            },
            link: function (scope, timeout) {
                scope.selected = {
                    'acl': false,
                    'readOnly': true
                };
                // Initialize terminology with defaults if not provided
                if (!scope.terminology) {
                    scope.terminology = terminologyService.getDefaultTerminology();
                }
                scope.$on('manage:ArchivePortfolioFromExisting', function (event, args) {
                    scope.acl = args.acl;
                    scope.portfolioName = args.treeID;
                    scope.nodeID = args.nodeID;
                    scope.dirty = false;
                    scope.portfolioNameExists = false;
                    scope.origPortfolioName = angular.copy(args.treeID);
                    scope.newACL = {
                        "group": {
                            "editors": [],
                            "portfolioAdmins": scope.acl.group.portfolioAdmins,
                            "viewers": []
                        },
                        "user": {
                            "editors": [],
                            "portfolioAdmins": [],
                            "viewers": []
                        }
                    };
                    $('#archivePortfolioFromExistingModal').modal('toggle');
                });
                scope.archiveCurrentPortfolio = function () {
                    var acl = scope.selected.acl ? scope.acl : scope.newACL;
                    scope.smartorgApi.archivePortfolio(scope.nodeID, scope.portfolioName, scope.origPortfolioName, scope.selected.readOnly, acl)
                        .then(function () {
                        scope.refreshForArchivePortfolio({ newPortfolioName: scope.portfolioName });
                        $('#archivePortfolioFromExistingModal').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        scope.portfolioNameExists = false;
                    })["catch"](function (err) {
                        $timeout(function () {
                            var errorMsg = scope.terminology.Portfolio + ' ' + scope.portfolioName + ' already exists.';
                            if (err.message.indexOf(errorMsg) == -1) {
                                errorMsg = scope.portfolioName + ' cannot be saved.';
                                scope.showAlert('danger', 'Error!', errorMsg);
                                scope.portfolioNameExists = false;
                            }
                            else {
                                scope.portfolioNameExists = true;
                            }
                        }, 0);
                    });
                };
                scope.showAlert = function (type, title, message) {
                    scope.$emit('workbench:alert', { type: type, title: title, message: message });
                };
                scope.checkDirty = function () {
                    scope.portfolioNameExists = false;
                    scope.dirty = !(scope.portfolioName == '' ||
                        scope.portfolioName == scope.origPortfolioName);
                };
                scope.resetPortfolio = function () {
                    scope.portfolioName = scope.origPortfolioName;
                    scope.selected = {
                        'acl': false,
                        'readOnly': true
                    };
                };
                /**
                 * For administrative menu items.
                 *
                 * @param command {string}
                 */
                scope.triggerEmit = function (command) {
                    scope.$emit('workbench:emit', {
                        command: command,
                        readOnly: false
                    });
                };
            }
        };
    }]);
//# sourceMappingURL=archive-portfolio-from-existing-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/archive-portfolio-from-existing/app/js/plumbing/archive-portfolio-from-existing-directive.js